import * as React from 'react';
import Helmet from 'react-helmet';
import { Config } from '../../config/index';
import { IArticle } from '../../definitions/news';
import { ArticlePreview } from '../../components/Article/Article';
import StaticBanner from '../../components/StaticBanner/index';
import LeadIn from '../../components/LeadIn/LeadIn';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';
import NewsBanner from '../../assets/images/news-banner.jpg';
import NewsBannerMobile from '../../assets/images/home-main-banner-mobile-1.png';

export default function NewsRender({ articles, pagination }) {
  const hasMoreResults = pagination && pagination.has_more_results ? pagination.has_more_results : undefined;

  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const NewsBannerImage = !!isMobile || !!isTablet ? NewsBannerMobile : NewsBanner;

        return (
          <React.Fragment>
            <Helmet>
              <title>News</title>
              <link rel="canonical" href={`${Config.FRONT_END_URL}/news`} />
              <meta name="description" content={'News'} />
            </Helmet>

            <StaticBanner
              title={'News'}
              bannerImg={{
                fit: 'cover',
                src: NewsBannerImage
              }}
            />

            <LeadIn title='Check out the latest from Tabacalera USA' />

            <div className="page page--news">
              <div className="container">
                <div className="row">
                  {articles.map((a: IArticle) => (
                    <div className="col-xs-12 col-sm-6" key={a._id}>
                      <ArticlePreview articleKey={a._id} article={a} />
                    </div>
                  ))}
                </div>

                {!!hasMoreResults &&
                  <div className="pagination">
                    <div className="row">
                      <div className="prev-btn col-xs-6">
                        <button
                          className="themed-btn theme-red"
                          onClick={this.prevPage}>
                          Prev
                    </button>
                      </div>

                      <div className="next-btn col-xs-6">
                        <button
                          className={`themed-btn theme-red ${!hasMoreResults && 'theme-btn-disabled'}`}
                          disabled={!hasMoreResults && true}
                          onClick={!!hasMoreResults ? this.nextPage : undefined}>
                          Next
                  </button>
                      </div>
                    </div>
                  </div>}

              </div>
            </div>
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/News/render.tsx